/**
 * Product page — stock request overlay (hidden until opened).
 */
(function () {
  function getOverlay() {
    return document.getElementById("lb-product-request-overlay");
  }

  function openOverlay(overlay) {
    if (!overlay) return;
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    overlay.hidden = false;
    overlay.classList.add("is-open");
    document.body.classList.add("lb-product-request-open");
    var first = overlay.querySelector("input, textarea");
    if (first && !overlay.querySelector("[role='status']")) {
      window.setTimeout(function () {
        first.focus();
      }, 50);
    }
  }

  function closeOverlay(overlay) {
    if (!overlay) return;
    overlay.hidden = true;
    overlay.classList.remove("is-open");
    document.body.classList.remove("lb-product-request-open");
  }

  function wire(root) {
    var overlay = getOverlay();
    var openBtn = root.querySelector("[data-lb-request-open]");
    if (!overlay || !openBtn) return;

    openBtn.addEventListener("click", function () {
      openOverlay(overlay);
    });

    overlay.querySelectorAll("[data-lb-request-close]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        closeOverlay(overlay);
      });
    });

    if (overlay.getAttribute("data-open-on-load") === "true") {
      openOverlay(overlay);
    }
  }

  document.querySelectorAll("[data-lb-product-request]").forEach(wire);

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var overlay = getOverlay();
    if (overlay && overlay.classList.contains("is-open")) {
      closeOverlay(overlay);
    }
  });
})();
